import Icon from '@material-ui/icons/Label';
import { RevisionList } from './RevisionList';

export default {
  list: RevisionList,
  icon: Icon,
};
